import { Component, ChangeDetectionStrategy, input, output, linkedSignal } from '@angular/core';
import {OrganizationAddress} from './organization-address';

import {FormsModule} from '@angular/forms';

@Component({
    selector: 'org-address-grid',
    templateUrl: './org-address-grid.component.html',
    styleUrls: ['./org-address-grid.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule]
})
export class OrgAddressGridComponent {

  listFilter!: string;
  fullList!: OrganizationAddress[];

  readonly addresses = input.required<OrganizationAddress[]>();

  readonly filteredAddresses = linkedSignal(() => this.addresses());

  public readonly addressSelected = output<OrganizationAddress>();

  public selectedRowId: number = -1;

  public selectRow(index: number, address: OrganizationAddress): void {
    this.selectedRowId = index;
    this.addressSelected.emit(address);
  }

  filterList(): void {
    if (!this.fullList) {
      this.fullList = JSON.parse(JSON.stringify(this.addresses()));
    }
    if (this.listFilter && this.listFilter.length > 0) {
      this.filteredAddresses.set(this.fullList.filter(address => this.filterMatches(address.attentionLine) || this.filterMatches(address.addressLine1)));
    } else {
      this.filteredAddresses.set(this.fullList);
    }
  }

  private filterMatches(input: string): boolean {
    if (!input) {
      return false;
    }
    let lowerInput = input.toLowerCase();
    let search = this.listFilter.toLowerCase();
    return lowerInput.indexOf(search) > -1;
  }

}

